module.exports = __webpack_public_path__ + "img/5.fa3c01b.png";